import React from 'react';

import { useAuth } from '../../contexts/AuthContext';
import { motion } from 'framer-motion';
import { FaLock, FaSpinner } from 'react-icons/fa';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isLoading, isAdmin } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-deep-space/60 via-cosmic-violet/55 to-black/70">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-center"
        >
          <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-cyber-blue to-neon-purple rounded-full flex items-center justify-center">
            <FaSpinner className="w-8 h-8 text-white animate-spin" />
          </div>
          <p className="text-white font-space-grotesk">Verificando autenticación...</p>
        </motion.div>
      </div>
    );
  }

  if (!isAuthenticated || (requireAdmin && !isAdmin)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-deep-space/60 via-cosmic-violet/55 to-black/70">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-md mx-4"
        >
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center">
            <FaLock className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-orbitron font-bold text-white mb-4">
            Acceso Denegado
          </h1>
          <p className="text-gray-300 font-space-grotesk mb-6">
            {!isAuthenticated 
              ? 'No tienes permisos para acceder a esta página. Por favor, autentícate como administrador.'
              : 'No tienes permisos de administrador para acceder a esta página.'
            }
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.history.back()}
            className="px-6 py-3 bg-gradient-to-r from-cyber-blue to-neon-purple text-white font-orbitron font-semibold rounded-xl hover:from-neon-purple hover:to-cyber-blue transition-all duration-300"
          >
            Volver
          </motion.button>
        </motion.div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute; 